export enum WalletType {
	Cash = 'cash',
	Bank = 'bank',
	Donate = 'donate',
}

export enum Currency {
	Ruble = 'ruble',
	Donate = 'donate',
}

export const walletTypeCurrency: { [key in WalletType]: Currency } = {
	[WalletType.Cash]: Currency.Ruble,
	[WalletType.Bank]: Currency.Ruble,
	[WalletType.Donate]: Currency.Donate,
};

export enum BankTransactionReason {
	StartingMoney = 'starting_money',
	BankTransferOutgoing = 'bank_transfer_outgoing',
	BankTransferIncoming = 'bank_transfer_incoming',
	BankExchange = 'bank_exchange',
	BuyVehicle = 'buy_vehicle',
	TestDrive = 'test_drive',
	CarWash = 'car_wash',
	BuyVehicleFuel = 'buy_vehicle_fuel',
	JobSalary = 'job_salary',
	JobExpenses = 'job_expenses',
	JobRentVehicle = 'job_rent_vehicle',
	StoreNumberPlate = 'store_number_plate',
	BuyNumberPlate = 'buy_number_plate',
	RefundHouse = 'refund_house',
	BuyHouse = 'buy_house',
	SellHouse = 'sell_house',
	PayForHouse = 'pay_for_house',
	DrivingLicenseExam = 'driving_license_exam',
	ExchangeOutgoing = 'exchange_outgoing',
	ExchangeIncoming = 'exchange_incoming',
	ExchangeTax = 'exchange_tax',
	BuyClothes = 'buy_clothes',
	BuyLootbox = 'buy_lootbox',
	BuyBundle = 'buy_bundle',
	CaseReward = 'case_reward',
	DailyTaskReward = 'daily_task_reward',
	BuyParkingSlot = 'buy_parking_slot',
	BuyTuningItems = 'buy_tuning_items',
	BuyFaceSurgery = 'buy_face_surgery',
	BuyVehiclePaint = 'buy_vehicle_paint',
	PromoCodeReward = 'promo_code_reward',
	Reward = 'reward',
	Respawn = 'respawn',
	VehicleDisposal = 'vehicle_disposal',
	VehicleRegister = 'vehicle_register',
	VehicleMarketPutOnSale = 'vehicle_market_put_on_sale',
	VehicleMarketSell = 'vehicle_market_sell',
	VehicleMarketBuy = 'vehicle_market_buy',
	VehicleServiceConsumableBuy = 'vehicle_consumable_buy',
	VehicleServiceEngineRepair = 'vehicle_engine_repair',
	InventoryExchange = 'inventory_exchange',
	BuyTattoos = 'buy_tattoos',
	DeleteTattoos = 'delete_tattoos',
	BuyHairstyle = 'buy_hairstyle',
	BuyCharacterSlot = 'buy_character_slot',
	BuyTechTuningItem = 'buy_tech_tuning_item',
	SellTechTuningItem = 'sell_tech_tuning_item',
	BuyTechTuningCase = 'buy_tech_tuning_case',
	BuyProductShop = 'buy_product_shop',
	LootBuyersSell = 'loot_buyers_sell',
	AdPlacement = 'ad_placement',
	DonateItemSell = 'donate_item_sell',
	DonateChangeName = 'donate_change_name',
	DonateBuyCurrencyBundle = 'donate_buy_currency_bundle',
	DonateGiveCurrencyBundle = 'donate_give_currency_bundle',
	RefundNumberPlate = 'refund_number_plate',
	RefundNickname = 'refund_nickname',
}

export const bankTransactionReasonTexts: { [key in BankTransactionReason]: string } = {
	[BankTransactionReason.StartingMoney]: 'Стартовые деньги',
	[BankTransactionReason.BankTransferOutgoing]: 'Перевод денег игроку',
	[BankTransactionReason.BankTransferIncoming]: 'Перевод денег от игрока',
	[BankTransactionReason.BankExchange]: 'Перевод между своими счетами',
	[BankTransactionReason.BuyVehicle]: 'Покупка транспорта',
	[BankTransactionReason.TestDrive]: 'Тест-драйв',
	[BankTransactionReason.CarWash]: 'Автомойка',
	[BankTransactionReason.BuyVehicleFuel]: 'Покупка топлива',
	[BankTransactionReason.JobSalary]: 'Зарплата на работе',
	[BankTransactionReason.JobExpenses]: 'Расходы на работе',
	[BankTransactionReason.JobRentVehicle]: 'Аренда рабочего транспорта',
	[BankTransactionReason.StoreNumberPlate]: 'Перенос номера в хранилище',
	[BankTransactionReason.BuyNumberPlate]: 'Покупка номерного знака',
	[BankTransactionReason.RefundHouse]: 'Возврат денег за удаленный дом',
	[BankTransactionReason.BuyHouse]: 'Покупка дома',
	[BankTransactionReason.SellHouse]: 'Продажа дома',
	[BankTransactionReason.PayForHouse]: 'Оплата дома',
	[BankTransactionReason.DrivingLicenseExam]: 'Попытка сдачи на права',
	[BankTransactionReason.ExchangeOutgoing]: 'Обмен',
	[BankTransactionReason.ExchangeIncoming]: 'Обмен',
	[BankTransactionReason.ExchangeTax]: 'Налог на обмен',
	[BankTransactionReason.BuyClothes]: 'Покупка одежды',
	[BankTransactionReason.BuyLootbox]: 'Покупка кейсов',
	[BankTransactionReason.BuyBundle]: 'Покупка набора',
	[BankTransactionReason.CaseReward]: 'Награда из кейса',
	[BankTransactionReason.DailyTaskReward]: 'Награда за выполнение ежедневного задания',
	[BankTransactionReason.BuyParkingSlot]: 'Покупка гаражного места',
	[BankTransactionReason.BuyTuningItems]: 'Покупка тюнинга',
	[BankTransactionReason.BuyFaceSurgery]: 'Проведение пластической операции',
	[BankTransactionReason.BuyVehiclePaint]: 'Покупка элементов покраски авто',
	[BankTransactionReason.PromoCodeReward]: 'Награда за промокод',
	[BankTransactionReason.Reward]: 'Награда',
	[BankTransactionReason.Respawn]: 'Восстановление здоровья',
	[BankTransactionReason.VehicleDisposal]: 'Утилизация транспорта',
	[BankTransactionReason.VehicleRegister]: 'Регистрация транспорта',
	[BankTransactionReason.VehicleMarketPutOnSale]: 'Покупка места на авторынке',
	[BankTransactionReason.VehicleMarketSell]: 'Продажа транспорта на авторынке',
	[BankTransactionReason.VehicleMarketBuy]: 'Покупка транспорта на авторынке',
	[BankTransactionReason.VehicleServiceConsumableBuy]: 'Обновление расходника авто',
	[BankTransactionReason.VehicleServiceEngineRepair]: 'Кап. ремонт двигателя авто',
	[BankTransactionReason.InventoryExchange]: 'Обмен через инвентарь',
	[BankTransactionReason.BuyTattoos]: 'Нанесение тату',
	[BankTransactionReason.DeleteTattoos]: 'Сведение тату',
	[BankTransactionReason.BuyHairstyle]: 'Услуги парикмахера',
	[BankTransactionReason.BuyCharacterSlot]: 'Слот для персонажа',
	[BankTransactionReason.BuyTechTuningItem]: 'Покупка элемента тех. тюнинга',
	[BankTransactionReason.SellTechTuningItem]: 'Продажа элемента тех. тюнинга',
	[BankTransactionReason.BuyTechTuningCase]: 'Копупка кейса со случайным элементов тех. тюнинга',
	[BankTransactionReason.BuyProductShop]: 'Покупка в магазине 24/7',
	[BankTransactionReason.LootBuyersSell]: 'Продажа предмета скупщику',
	[BankTransactionReason.AdPlacement]: 'Размещение объявления',
	[BankTransactionReason.DonateItemSell]: 'Продажа предмета из донат-инвентаря',
	[BankTransactionReason.DonateChangeName]: 'Смена имени и фамилии',
	[BankTransactionReason.DonateBuyCurrencyBundle]: 'Покупка набора валюты',
	[BankTransactionReason.DonateGiveCurrencyBundle]: 'Выдача набора валюты',
	[BankTransactionReason.RefundNumberPlate]: 'Возврат средств за отклоненный номерной знак',
	[BankTransactionReason.RefundNickname]: 'Возврат средств за отклоненную смену никнейма',
};
